import { Routes, mapToCanActivate } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { AuthGuard } from '@next/core-lib/authorization';

import { AppWizardComponent } from './app-wizard/app-wizard.component';
import { BusinessPartnerBackofficeComponent } from './business-partner-backoffice/business-partner-backoffice.component';
import { DevAuthComponent } from './dev-auth/dev-auth.component';
import { DevTokensComponent } from './dev-tokens/dev-tokens.component';
import { InformationComponent } from './information/information.component';
import { LabresultComponent } from './labresults/labresult.component';
import { ProfileComponent } from './profile/profile.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'information',
    pathMatch: 'full',
  },
  {
    path: 'information',
    component: InformationComponent,
    canActivate: mapToCanActivate([AuthGuard]),
  },
  {
    path: 'labresults',
    component: LabresultComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'labresults',
    },
  },
  {
    path: 'business-partner-backoffice',
    component: BusinessPartnerBackofficeComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'businessPartnerBackoffice',
    },
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'profile',
    },
  },
  {
    path: 'app-wizard',
    component: AppWizardComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'Digital App Management Wizard',
    },
  },
  {
    path: 'developer-auth',
    component: DevAuthComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'dev_api_tool',
    },
    children: [{ path: 'developer-auth', component: DevAuthComponent }],
  },
  {
    path: 'developer-tools',
    component: DevTokensComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'jwt_token',
    },
    children: [{ path: 'developer-tools', component: DevTokensComponent }],
  },
  ...coreRoutes,
];
